import { useState } from "react";

// components
import { useTranslation } from "react-i18next";
import PrimaryButton from "../../../../components/common/PrimaryButton";
import Spinner from "../../../../components/common/Spinner";
import { LOGIN } from "../../constants";
import { login as oidcLogin } from "../../../../setup/auth/oidc";

/**
 * Staff sign-in for admin.waffyapp.com.
 *
 * The legacy username/password (OAuth2 password-grant) form was replaced by a
 * single button that redirects to Keycloak (waffy-staff realm, admin-app
 * client, Authorization Code + PKCE). Staff authenticate with their
 * @waffyapp.com Google account via Keycloak; there are no local credentials.
 *
 * See src/setup/auth/oidc.ts and design doc 05-staff-sso-google.md.
 */
const LoginForm = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const onSignIn = () => {
    setLoading(true);
    // Full-page redirect to Keycloak; resolves only on failure (otherwise navigates away).
    oidcLogin().catch(() => setLoading(false));
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        alignItems: "center",
        marginTop: "64px",
        width: "100%",
        padding: "0 16px",
      }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "32px",
          width: "100%",
          maxWidth: "534px",
        }}>
        <h1 style={{ marginBottom: "16px" }}>{t("lbl_login_title")}</h1>
        <PrimaryButton
          disabled={loading}
          type="button"
          onClick={onSignIn}
          style={{
            width: "100%",
            height: "52px",
            borderRadius: "8px",
            background: loading ? "#E2E5EE" : "#0D44AD",
            textAlign: "center",
            whiteSpace: "nowrap",
            fontSize: "14px",
            lineHeight: "100%",
            fontWeight: 500,
          }}>
          {loading ? <Spinner /> : `${LOGIN}`}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default LoginForm;
